import { atom, selector } from 'recoil';
import Client from 'shopify-buy';
import { pushProductVariantDetailsToDataLayer } from '../dataLayer/productDetail';
import { returnShopifyVariant } from '../globals';

const client = Client.buildClient({
  domain: process.env.GATSBY_SHOPIFY_URL,
  storefrontAccessToken: process.env.GATSBY_SHOPIFY_ACCESS_TOKEN,
});

// State used for storing product details on product page
export const productState = atom({
  key: 'productState',
  default: null,
});

// State used for storing product pack details on product pack page
export const productPackState = atom({
  key: 'productPackState',
  default: [null],
});

// State used for storing current step of each product selection
export const productPackStepOptionState = atom({
  key: 'productPackStepOptionState',
  default: [],
});

// State use for resetting product state back to initial static value (optin behaviour)
export const staticProductState = atom({
  key: 'staticProductState',
  default: null,
});

export const variantState = atom({
  key: 'variantState',
  default: null,
});

export const productWithLiveShopifyState = selector({
  key: 'productWithLiveShopifyState',
  get: async ({ get }) => {
    const product = get(productState);

    if (product?.fields) {
      const newShopifyProduct = await client.product?.fetch(
        product.fields.shopifyData.id
      );

      const variants = newShopifyProduct?.variants.map((v, idx) => ({
        ...product.fields.shopifyData.variants[idx],
        availableForSale: v.available,
      }));

      return {
        ...product.fields.shopifyData,
        variants,
      };
    }
    return null;
  },
});

export const shopifyVariantsState = selector({
  key: 'shopifyVariantsState',
  get: async ({ get }) => {
    const product = get(productWithLiveShopifyState);
    const variant = get(variantState);

    if (product) {
      const shopifyVariants = returnShopifyVariant(product, variant);

      if (shopifyVariants.length > 0) {
        pushProductVariantDetailsToDataLayer(shopifyVariants[0]);
      }

      return returnShopifyVariant(product, variant);
    } else {
      return [];
    }
  },
});
